import { h } from 'vue'

import { ALIASES, ICONS } from './icon_names.js'
import ICON_PATHS from './icon_paths.js'

import './icon.scss'

// Font Awesome's transform language ('shrink-6 up-9 rotate-20': sixteenths
// of the icon, degrees) as a CSS transform; layered icons still use it
export const iconTransform = (transform = '', flip = null) => {
  let x = 0
  let y = 0
  let scale = 1
  let rotate = 0
  for (const token of transform.split(/\s+/).filter(Boolean)) {
    const [kind, amount] = token.split('-')
    const n = Number(amount) || 0
    if (kind === 'shrink') scale -= n / 16
    else if (kind === 'grow') scale += n / 16
    else if (kind === 'up') y -= n / 16
    else if (kind === 'down') y += n / 16
    else if (kind === 'left') x -= n / 16
    else if (kind === 'right') x += n / 16
    else if (kind === 'rotate') rotate += n
  }
  const parts = []
  if (flip === 'horizontal') parts.push('scale(-1, 1)')
  if (x || y) parts.push(`translate(${x}em, ${y}em)`)
  if (scale !== 1) parts.push(`scale(${scale})`)
  if (rotate) parts.push(`rotate(${rotate}deg)`)
  return parts.length ? parts.join(' ') : undefined
}

// the icon's name and weight from a name or a ['fas'|'far', name] pair:
// solid shows the filled icon (a favorited star), anything else the outline
const resolve = (icon) => {
  const [prefix, name] = Array.isArray(icon) ? icon : [null, icon]
  return {
    name: ALIASES[name] ?? name,
    weight: prefix === 'fas' ? 'fill' : 'regular',
  }
}

const warned = new Set()

// An icon from the Phosphor set, drawn in place of Font Awesome's
// component: same tag, same props, same class names for the CSS.
export default {
  name: 'Icon',
  props: {
    icon: { type: [String, Array], required: true },
    spin: Boolean,
    size: { type: String, default: null },
    fixedWidth: Boolean,
    flip: { type: String, default: null },
    transform: { type: String, default: '' },
  },
  render() {
    const { name, weight } = resolve(this.icon)
    const shapes = ICON_PATHS[ICONS[name]]
    if (!shapes) {
      if (process.env.NODE_ENV !== 'production' && !warned.has(name)) {
        warned.add(name)
        console.warn(`No icon named "${name}"`)
      }
      return null
    }
    return h('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 256 256',
      fill: 'currentColor',
      innerHTML: shapes[weight] ?? shapes.regular,
      class: [
        'svg-inline--fa',
        'Icon',
        {
          'fa-spin': this.spin,
          'fa-fw': this.fixedWidth,
          [`fa-${this.size}`]: this.size,
          'fa-flip-horizontal': this.flip === 'horizontal',
        },
      ],
      style: { transform: iconTransform(this.transform, this.flip) },
      'aria-hidden': 'true',
      focusable: 'false',
    })
  },
}
